import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import request from "../../lib/requester";
import _ from "lodash";
import ReactExport from "react-export-excel";
import moment from "moment";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Approval extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      dataTable: [],
      baseTable: [],
      search: "",
      user: JSON.parse(window.localStorage.getItem("is_user")),
    };
  }

  componentDidMount = () => {
    let url = "/api/traces/v1/program/list-approve";
    let param = {
      org_id: this.state.user.org_id,
    };
    this.setState({ loading: true });
    request.postTraces(url, param, {
      success: function (response) {
        let { data } = response.data;
        data.map((item, index) => {
          item.formatted_start_date = moment(item.start_date).format(
            "DD-MM-YYYY"
          );
          item.formatted_end_date = moment(item.end_date).format("DD-MM-YYYY");
          return item;
        });
        this.setState({ loading: false, dataTable: data, baseTable: data });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "PRGORAM NO",
          accessor: "program_number",
          filterable: true,
        },
        {
          Header: "REF NO",
          accessor: "ref_number",
          filterable: true,
        },
        {
          Header: "PROGRAM TYPE",
          accessor: "program_name",
          filterable: true,
        },
        {
          Header: "DESCRIPTION",
          accessor: "description",
          filterable: true,
        },
        {
          Header: "PRINCIPAL",
          accessor: "org_name",
          filterable: true,
        },
        {
          Header: "START DATE",
          accessor: "start_date",
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null
                  ? moment(row.value).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
        },
        {
          Header: "END DATE",
          accessor: "end_date",
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null
                  ? moment(row.value).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
        },
        // {
        //     Header: 'BUDGET TYPE',
        //     accessor: 'budget_type'
        // },
        {
          Header: "SUBMITTED DATE",
          accessor: "creation_date",
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null
                  ? moment(row.value).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
        },
        {
          Header: "BUDGET",
          accessor: "budget",
          Cell: (row) => (
            <span>
              {row.value
                ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                : "0"}
            </span>
          ),
        },
        {
          Header: "",
          accessor: "program_id",
          Cell: (row) => (
            <span>
              <button
                className="btn btn-success btn-sm"
                onClick={() => {
                  this.goDetail(row);
                }}
              >
                Approve <i className="fas fa-check" />
              </button>
            </span>
          ),
        },
      ],
      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        className="fullWidth"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = "";
          switch (filter.id) {
            default:
              columnes = row[filter.id];
          }

          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
      />
    );
  };

  badgeClass = (status) => {
    let className = "";
    if (status === "P") {
      className = "badge badge-info";
    } else if (status === "A") {
      className = "badge badge-success";
    } else if (status === "R") {
      className = "badge badge-danger";
    } else {
      className = "badge badge-secondary";
    }
    console.log(className);
    return className;
  };

  mappingStatus = (status) => {
    let mappingStatus = "";
    if (status === "P") {
      mappingStatus = "PROPOSE";
    } else if (status === "A") {
      mappingStatus = "APPROVED";
    } else if (status === "R") {
      mappingStatus = "REJECT";
    }

    return mappingStatus;
  };

  exportToExcel = () => {
    const dataSet2 = this.state.dataTable;
    let filename =
      "program-summary-" + moment(new Date()).format("DDMMYYYYHHmmss");

    return (
      <ExcelFile
        filename={filename}
        fileExtension="xlsx"
        element={
          <button className="btn btn-success">
            <i className="fas fa-file-excel" />
          </button>
        }
      >
        <ExcelSheet data={dataSet2} name="Leaves">
          <ExcelColumn label="Ref No" value="ref_number" />
          <ExcelColumn label="Program Type" value="program_name" />
          <ExcelColumn label="Description" value="description" />
          <ExcelColumn label="Customer" value="customer" />
          <ExcelColumn label="Principal" value="org_name" />
          <ExcelColumn label="Start Date" value="formatted_start_date" />
          <ExcelColumn label="End Date" value="formatted_end_date" />
          {/* <ExcelColumn label="Budget Type" value="budget_type" /> */}
          <ExcelColumn label="Submitted Date" value="creation_date" />
          <ExcelColumn label="Member" value="member_name" />
          <ExcelColumn label="Status" value="status" />
        </ExcelSheet>
      </ExcelFile>
    );
  };

  goDetail = (rows) => {
    let { row } = rows;
    this.props.history.push("/admin/program/approval/" + row.program_id);
  };

  handleSearch = (e) => {
    let value = e.target.value;
    this.setState({ search: value });
    let baseTable = _.filter(this.state.baseTable, function (o) {
      return o.description.toLowerCase().includes(value.toLowerCase());
    });
    this.setState({ dataTable: baseTable });
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    {/* <div className="row">
                                            <div className="col-lg-4">
                                                <input type="text" className="form-control" placeholder="Search Program..." onChange={ this.handleSearch.bind(this) } />
                                            </div>
                                        </div> */}
                    <div className="clearfix">&nbsp;</div>
                    <div className="row">
                      <div className="col-lg-12">{this.renderTable()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Approval;
